<template>
  <div id="user-rights">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <el-form
                ref="formselect"
              :model="formselect"
              label-width="85px"
              class="queryform_div"
        >
          <el-row :gutter="24">
            <el-col :md="6" :xs="24" :sm="12">
              <el-form-item :label="$t('desc.keyword')">
                <el-input size="small" v-model="formselect.keywords" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :md="6" :xs="24" :sm="12">
              <el-form-item :label="$t('desc.dsn')">
                <el-input v-model="formselect.dsn" size="small" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="6" :xs="24" :sm="12">
              <el-form-item :label="$t('desc.gsn')">
                <el-input v-model="formselect.gsn" size="small" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="6" :xs="24" :sm="12">
              <el-form-item :label="$t('desc.ccn')">
                <el-input v-model="formselect.ccn" size="small" style="width:100%"></el-input>
              </el-form-item>
            </el-col> -->
             <el-col :md="16" :sm="12" :xs="24">
                <el-form-item
                  :label="$t('title.Datefrom')"
                  style="min-height: 41px"
                >
                  <el-date-picker
                    v-model="times"
                    type="daterange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    align="right"
                    unlink-panels
                    :range-separator="$t('title.to')"
                    :start-placeholder="$t('title.beginDate')"
                    :end-placeholder="$t('title.endDate')"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
             <!-- <el-col :md="6" :xs="24" :sm="12">
                <el-form-item :label="$t('title.logType')">
                  <el-select
                    v-model="formselect.logType"
                    size="small"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                  >
                    <el-option value="all" :label="$t('desc.all')"></el-option>
                    <el-option
                      v-for="(item, index) in lotTypeList"
                      :value="item.bnDictCode"
                      :label="item.bnDictName"
                      :key="'inx2' + index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            
            <el-col :md="6" :xs="24" :sm="12">
              <el-form-item :label="$t('desc.operateUser')">
                <el-input size="small" v-model="formselect.userName" style="width:100%"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :md="6" :xs="24" :sm="12" style="margin-top: 6px">
              <el-button @click="getData" type="primary" size="small">{{
                $t("button.query")
              }}</el-button>
              <el-button @click="reset" size="small">{{
                $t("button.reset")
              }}</el-button>
            </el-col>
          </el-row>
        </el-form>
        <template>
          <div class="tableDiv">
          <el-table :data="tableData" stripe  v-loading="loading" :empty-text="$t('desc.noData')">
            <el-table-column
              type="index"
              :label="$t('title.serialNumber')"
               width="60"
            ></el-table-column>
            <el-table-column
              prop="actionName"
              :label="$t('title.logType')"
              min-width="10%"
            ></el-table-column>
            <el-table-column
              prop="title"
              :label="$t('title.logTitle')"
              min-width="10%"
            ></el-table-column>
            <el-table-column
              prop="content"
              :label="$t('title.logContent')"
              min-width="40%"
            ></el-table-column>
            <el-table-column
              :label="$t('title.loginTime')"
              min-width="10%"
            >
              <template slot-scope="scope">
                {{scope.row.creationTime | dateFormat}}
              </template>
            </el-table-column>
            <!-- <el-table-column
              prop="errorMsg"
              :label="$t('title.errorMsg')"
              min-width="10%"
            ></el-table-column> -->
             <el-table-column
              prop="userName"
              :label="$t('desc.loginUser')"
              min-width="10%"
            ></el-table-column>
            <!-- <el-table-column
              prop="remark"
              :label="$t('title.remark')"
            ></el-table-column> -->
          </el-table>
          <el-pagination
            background
            :page-size="pagination.pageSize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            layout="prev, pager, next,sizes"
            :total="pagination.totalPage"
            style="text-align: center; margin-top: 10px"
          >
          </el-pagination>
          </div>
        </template>
      </el-main>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetAllLoginLogs ,getLogTypeList} from "../../api/api";

export default {
  name: "loginLog",
  data() {
    return {
      loading: false,
      times: ["", ""],
      tableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        totalPage: 0,
      },
      formselect: {
        keywords: "",
        startTime: "",
        endTime: "",
        logType: "",
        userName:""
      },
      lotTypeList:[]
    };
  },
  mounted() {
    this.getData();
    this.getLogTypeData()
  },
  methods: {
    reset() {
      this.times = ["", ""];
      this.formselect = { keywords: "", startTime: "", endTime: "", logType: "" ,userName:""};
      this.getData();
    },
    getData() {
      this.loading = true;
      this.formselect.startTime = this.times[0];
      this.formselect.endTime = this.times[1];
      if (this.formselect.logType == "all") {
        this.formselect.logType = "";
      }
      var data = {
          skipCount: (this.pagination.current - 1) * this.pagination.pageSize,
          maxResultCount:this.pagination.pageSize
        },
        that = this;
      data = { ...data, ...this.formselect };
      GetAllLoginLogs(data).then((res) => {
        if (res.success) {
          that.tableData = res.result.items;
          that.pagination.totalPage = res.result.totalCount;
        }
        that.loading = false;
      });
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
       this.getData();
    },
    getLogTypeData(){
      getLogTypeList().then((res)=>{
        if (res.success) {
          res.result.forEach(item => {
            if(item.bnTypeCode=='OperateLog'){
              this.lotTypeList.push(item)
            }
          });
        }
      })
    }
  },

  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>

<style scoped>
</style>
